import { GameLobbyEnum, JackpotGameProviderEnum, KeyEnum } from '~/enums'
import type { GameItemExtend } from '~/types/game'
import { useGameSpecificEvents } from '~/composables/tracking-events/use-game-specific-events'
import { useUserBehaviorEvents } from '~/composables/tracking-events/use-user-behavior-events'
import { GAME_DEFAULT } from '~/resources/game'
import cacheManager from '#lib/utils/cache-manager'

export const useTopJackpot = () => {
  const route = useRoute()
  const { isLogged } = useUser()
  const { jackpots } = useJackpot()
  const { onPlayGame } = usePlayGame()
  const { requestFetchGames } = useLobbyGames()
  const { trackingGameStarted } = useGameSpecificEvents()
  const { trackingButtonClick } = useUserBehaviorEvents()

  const { data: slotGames } = useAsyncData(KeyEnum.JackpotGame, async () => {
    const cachedData = cacheManager.get(KeyEnum.JackpotGame)
   
    try {
      if (cachedData) {
        return cachedData
      }
      const dataGames =  await requestFetchGames({
        cats: GameLobbyEnum.Slots,
        limit: -1,
        prov: JackpotGameProviderEnum.Techplay,
      })
      cacheManager.set(KeyEnum.JackpotGame, dataGames)
      return dataGames
    } catch {
      if (cachedData) {
        return cachedData
      }
      return []
    }
  })
  const handlePlayingGame = (item: GameItemExtend): void => {
    trackingButtonClick({
      buttonId: `play-game-id-${item.gameId}`,
      buttonName: 'play-game-home',
      pageUrl: route.fullPath,
    })

    onPlayGame(item)

    if (isLogged.value) {
      trackingGameStarted({
        gameId: item.gameId,
        gameType: item.category?.[0] ?? item.gameType ?? '',
        gameName: item.title,
      })
    }
  }

  const jackpotGameSorting = computed(() => {
    if (!slotGames.value?.length) {
      return []
    }

    const sortedGames = slotGames.value
      ?.map((item: { gameId: string | number }) => ({
        ...item,
        jackpotNumber: item.gameId ? jackpots.value?.[item.gameId] : 0,
      }))
      .sort((a: { jackpotNumber: number }, b: { jackpotNumber: number }) => (b.jackpotNumber || 0) - (a.jackpotNumber || 0))

    return sortedGames.slice(0, 11)
  })

  const gameJackpotTopOne = computed((): GameItemExtend => {
    return jackpotGameSorting.value?.length
      ? jackpotGameSorting.value[0]
      : GAME_DEFAULT
  })

  return {
    handlePlayingGame,
    jackpotGameSorting,
    gameJackpotTopOne,
  }
}
